import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { LEGAL_NOTE, NAV_ITEMS, SITE, trackEvent } from "@/lib/site";
import { ArrowUpRight, LockKeyhole } from "lucide-react";
import { Link } from "wouter";
const legal = [["Nordzypern kennenlernen", "/nordzypern-erleben"], ["Über uns", "/ueber-uns"], ["FAQ", "/faq"], ["Kontakt", "/kontakt"], ["Impressum", "/impressum"], ["Datenschutz", "/datenschutz"], ["Rechtliche Hinweise", "/rechtliche-hinweise"]] as const;
export function PublicFooter() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  return <footer className="bg-[#101010] text-[#F7F3EB]">
      <section className="container border-b border-white/10 py-20 lg:py-28">
        <div className="grid gap-10 lg:grid-cols-[1.25fr_.75fr] lg:items-end">
          <div>
            <p className="eyebrow mb-6 text-[#D8BC88]">{tx("IHR SERVICE RUND UM NORDZYPERN")}</p>
            <h2 className="display-lg max-w-4xl font-semibold">{tx("Ein Ansprechpartner.")}<br />{tx("Für Ihren nächsten Schritt.")}</h2>
            <p className="mt-6 max-w-2xl text-base leading-8 text-white/75">{tx("Immobilien, Kennenlernen, Business, Banking oder Neustart: Erzählen Sie uns von Ihren Zielen. Wir bringen die passenden Services und Spezialisten zusammen.")}</p>
          </div>
          <div className="flex flex-col gap-3 lg:items-end">
            <Button asChild size="lg" className="w-full rounded-none bg-[#C4A46B] px-7 text-xs font-bold tracking-[.12em] text-[#101010] hover:bg-[#d3b984] lg:w-auto">
              <Link href="/setup-check" onClick={() => trackEvent("setup_check_started", {
              placement: "footer"
            })}>{tx("SETUP-CHECK STARTEN ")}<ArrowUpRight /></Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="w-full rounded-none border-white/25 bg-transparent px-7 text-xs font-bold tracking-[.12em] text-white hover:bg-white hover:text-black lg:w-auto">
              <Link href="/kontakt">{tx("PERSÖNLICHEN TERMIN ANFRAGEN")}</Link>
            </Button>
          </div>
        </div>
      </section>
      <section className="container py-14">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr]">
          <div>
            <img src={SITE.logo} alt={tx("CYPRUS PRIVÉ")} className="h-28 w-28 object-contain" />
            <p className="mt-5 text-[10px] font-bold tracking-[.18em] text-[#D8BC88]">{tx("IHR SERVICE RUND UM NORDZYPERN")}</p>
            <Link href="/private-investments" className="mt-5 block text-sm leading-6 text-[#E1C998]">{tx("Investments ausschließlich auf Anfrage.")}<br />{tx("Individuell abgestimmte Konditionen.")}</Link>
            <p className="mt-6 max-w-md text-xs leading-6 text-white/65">{tx(LEGAL_NOTE)}</p>
            <Link href="/private" className="mt-6 inline-flex items-center gap-2 text-xs font-semibold tracking-[.12em] text-white/70 hover:text-[#C4A46B]"><LockKeyhole className="h-4 w-4" />{tx(" PRIVATE ACCESS LOGIN")}</Link>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div className="space-y-3">{tx(NAV_ITEMS.slice(1, 6).map(item => <Link key={item.href} href={item.href} className="block text-sm text-white/65 hover:text-white">{tx(item.label)}</Link>))}</div>
            <div className="space-y-3">{tx(NAV_ITEMS.slice(6).map(item => <Link key={item.href} href={item.href} className="block text-sm text-white/65 hover:text-white">{tx(item.label)}</Link>))}</div>
            <div className="space-y-3">{tx(legal.map(([label, href]) => <Link key={href} href={href} className="block text-sm text-white/65 hover:text-white">{tx(label)}</Link>))}</div>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-[10px] tracking-[.12em] text-white/65 sm:flex-row sm:items-center sm:justify-between">
          <p>© {tx(new Date().getFullYear())}{tx(" CYPRUS PRIVÉ. ALLE RECHTE VORBEHALTEN.")}</p>
          <p>{tx("IMMOBILIEN · BUSINESS · BANKING · RELOCATION · INVESTMENTS AUF ANFRAGE")}</p>
        </div>
      </section>
    </footer>;
}
